import { render, staticRenderFns } from "./CustomerGeneralSettings.vue?vue&type=template&id=0eee78f3&scoped=true&"
import script from "./CustomerGeneralSettings.vue?vue&type=script&lang=js&"
export * from "./CustomerGeneralSettings.vue?vue&type=script&lang=js&"
import style0 from "./CustomerGeneralSettings.vue?vue&type=style&index=0&id=0eee78f3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eee78f3",
  null
  
)

export default component.exports